<template>
  <div>
    <el-container style="height:100vh; border: 1px solid #eee">
      <el-aside width="200px;height:100vh;">
        <div style="width: 100%">
          <LabelHeader msg="组织机构"></LabelHeader>


          <div class="buttons" style="margin: 5px 0px;">
            <el-button @click="expandAll" size="mini" plain round type="primary" style="width: 40%">展开</el-button>
            <el-button @click="foldAll" size="mini" plain round type="warning" style="width: 40%">收起</el-button>
          </div>
          <el-tree
                  :props="treeProps"
                  :highlight-current="true"
                  :default-expand-all="expandAlls"
                  :data="dataTree"
                  ref="menu"
                  node-key="id"
                  @node-click="go"
                  :expand-on-click-node="false"
          >
          </el-tree>
        </div>
      </el-aside>

      <el-main style="padding: 0px 5px;">
        <div>
          <LabelHeader :msg="preTit"></LabelHeader>
          <div style="padding-left: 20px">
            <el-form style="padding-top: 10px;" :inline="true">
              <el-form-item label="工号：">
                <el-input
                        size="small"
                        type="text"
                        v-model="accText"
                        placeholder="输入工号查询"
                        maxlength="6"
                        onkeyup="value=value.replace(/[^\d\.]/g,'')"
                        style="width: 170px"
                />
              </el-form-item>
              <el-form-item label="姓名：">
                <el-input size="small" style="width: 170px" class="ML-10" type="text" v-model="nameText" placeholder="输入姓名查询" />
              </el-form-item>
              <el-form-item>
                <el-switch v-model="check2" :small="true" size="mini" active-text="全局查询"></el-switch>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="list()" size="mini" icon="el-icon-search">查询</el-button>
              </el-form-item>
            </el-form>
          </div>

          <LabelHeader msg="查询结果"></LabelHeader>

          <div class="buttonBox">
            <el-button type="primary" size="mini" icon="el-icon-circle-plus-outline" @click="editDialogVisible=true">新增 </el-button>
            <el-button type="primary" size="mini" @click="openUpload()" v-show="leven"> 批量导入 </el-button>
            <el-button type="warning" size="mini" icon="el-icon-edit" @click="updateBindParam()" v-show="leven">修改 </el-button>
            <el-button type="primary" @click="possword" size="mini" v-show="leven" icon="el-icon-circle-plus-outline">重置密码 </el-button>
            <el-button type="danger" size="mini" icon="el-icon-user" @click="removeitem" v-show="leven">离职</el-button>
            <el-button type="success" size="mini" icon="el-icon-s-custom" @click="bangding()" v-show="leven">绑定 </el-button>
            <el-button type="primary" size="mini" icon='class="el-icon-share' @click="openView()">查看权限</el-button>
          </div>
          <div>
            <el-table
                    :data="datas"
                    style="width: 100%"
                    row-key="id"
                    max-height="530"
                    border
                    stripe
                    lazy
                    show-checkbox
                    :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
                    @selection-change="handleSelectionChange"
            >
              <af-table-column :width="40" align="center" type="selection"></af-table-column>
              <af-table-column prop="account" label="工号" align="center" ></af-table-column>
              <af-table-column prop="name" label="姓名" align="center"></af-table-column>
              <af-table-column prop="teamName" label="单位" align="center"></af-table-column>
              <af-table-column prop="sex" label="性别" align="center" ></af-table-column>
              <af-table-column prop="phoneNum" label="电话" align="center"></af-table-column>
               <af-table-column prop="ext1" label="人天成本" align="center" ></af-table-column>
              <af-table-column prop="status" label="状态" align="center" ></af-table-column>
              <af-table-column prop="createAt" label="创建时间" align="center" :width="160"></af-table-column>
            </el-table>

            <el-dialog :title="dialogTitle" :visible.sync="editDialogVisible">
              <Edit :params="editParams" @close="close" @success="success" ref="bindEditForm"></Edit>
            </el-dialog>

            <el-dialog
                    v-dialogDrag
                    v-if="BindOpen"
                    title="授权列表"
                    :visible.sync="BindOpen"
                    :modal="false"
                    :close-on-click-modal="false"
                    width="840px"
            >
              <BindEdit :params="{ id: userId }" @close="close" @success="success"></BindEdit>
            </el-dialog>
            <el-dialog v-dialogDrag title="文件导入" v-if="comPer" :visible.sync="comPer" :modal="false" width="600px">
              <fileUpload :params="uploadObj" @close="close" @success="success()"></fileUpload>
            </el-dialog>
            <el-dialog v-dialogDrag v-if="syncView" :visible.sync="syncView" :modal="false" class="rap" title="查看权限">
              <!--              <RAP :user="user" />-->
            </el-dialog>
            <div style="margin-top: 15px; display: flex; flex-wrap: nowrap; padding: 10px; justify-content: flex-end">
              <el-pagination
                      layout="total, sizes, prev, pager, next, jumper"
                      :page-sizes="[10, 20, 50, 100]"
                      :total="pagination.total"
                      @size-change="sizeChange"
                      @current-change="currentChange"
                      :page-size="pagination.size"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </el-main>
    </el-container>
  </div>
</template>
<script>
  import LabelHeader from "../../components/LabelHeader";
import Edit from './edit';
import BindEdit from './userBind';

export default {
  props: {
    params: Object
  },
  data() {
    return {
      editDialogVisible: false,
      detailDialogVisible: false,
      syncView: false,
      elTrees: true,
      expandAlls: false,
      leavenum: '', // 离职
      dataTree: [], // tree数据
      teamId: '',
      dialogTitle: '新增用户', // 标题
      id: '',
      idval: '',
      leven: true, // 离职隐藏
      listitem: [],
      idParam: '',
      check2: true,
      refreshing: false, // 结果列表是否正在刷新
      datas: [],
      userId: null,
      OpenName: false,
      accText: '',
      nameText: '',
      BindOpen: false,
      removepeople: false, // 离职页
      pagination: {
        page: 1,
        size: 10,
        total: 0
      },
      editParams: {
        id: '',
        tree: [],
        teamName: '',
        teamId: ''
      },
      treeProps: {//el-tree默认取数据中哪个字段
        children: 'children',
        label: 'name'
      },
      comPer: false,
      user: {},
      uploadObj: {},
      preTit: ''
    };
  },
  components: { Edit, BindEdit ,LabelHeader},
  // 页面加载获取数据
  mounted() {
    this.tree();
  },
  methods: {
    openEditDialog() {
      this.dialogTitle = '新增用户';
      this.editParams.id = null;
      this.OpenName = true;
    },
    sizeChange(size) {
      this.pagination.size = size;
      this.list();
    },
    currentChange(pageNo) {
      this.pagination.page = pageNo;
      this.list();
    },
    expandAll() {
      this.elTrees = false;
      this.expandAlls = true;
      this.$nextTick(() => {
        this.elTrees = true;
      });
    },
    foldAll() {
      this.elTrees = false;
      this.expandAlls = false;
      this.$nextTick(() => {
        this.elTrees = true;
      });
    },
    bangding() {
      if (checkSelect(this.listitem)) {
        this.BindOpen = true;
        this.userId = this.idParam;
      }
    },
    handleSelectionChange(row) {
      if(row.length > 0){
        this.listitem = row;
        this.idParam = row[0].id;
      }
    },
    openUpload() {
      this.uploadObj.code = this.teamId;
      this.comPer = true;
      this.uploadObj.template = `${$api_eap.user.template}`;
      this.uploadObj.upload = `${$api_eap.user.upload}`;
    },
    updateBindParam() {
      // if (checkSelect(this.listitem)) {
      this.editParams.id = this.idParam;
      this.OpenName = true;
      this.dialogTitle = '修改用户';
      this.editParams.tree = this.dataTree;
      this.OpenName = true;
      // }
    },
    close() {
      this.OpenName = false;
      this.BindOpen = false;
      this.comPer = false;
    },
    success() {
      this.OpenName = false;
      this.BindOpen = false;
      this.comPer = false;
      this.list();
      this.tree();
    },
    tree() {
      httpKit.post($api_eap.team.tree).then(res => {
        if (res.data.code === '200') {
          if (res.data.data.length > 0) {
            this.dataTree = res.data.data;
            this.teamId = res.data.data[0].id;
            this.preTit = res.data.data[0].name + '下属用户';
            this.idval = this.teamId;
            sessionStorage.setItem('userIdval', this.idval);
            // treeFor(this.dataTree, 'name');
            this.list();
          }
        }
      });
    },
    // 重置密码
    possword() {
      let selection = this.listitem;
      if (checkSelect(this.listitem)) {
        this.$confirm('您确定重置此用户的密码吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let par = {
            userId: selection[0].id
          };
          httpKit.post($api_lims.user.resetPassword, par).then(res => {
            if (res.data.code === '200') {
              this.$message.success('重置密码成功');
            } else {
              this.$message.error('重置密码失败');
            }
          });
        });
        this.userId = selection[0].id;
      }
    },
    // 离职
    removeitem() {
      let selection = this.listitem;
      let ids = selection[0].id;
      let status = selection[0].status;
      if (status === '在职' || status === 'live' || status === 'leave' || status === '活跃') {
        this.$confirm('您确定此人要离职吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            let loading = this.$loading({ text: '保存中，请稍等' });
            httpKit.post($api_eap.user.leave, { id: ids }).then(res => {
              this.pagination.size = 10;
              loading.close();
              this.removeCallback(res);
              this.list(res);
              this.tree();
            });
          })
          .catch(() => {
            this.$message.error('已取消');
          });
      } else {
        this.$message.warning('该用户已离职');
      }
    },
    removeCallback(res) {
      if (res) {
        this.$message.success('操作成功');
      } else if (res.data.code === '500') {
        this.$message.error('操作失败:' + res.data.msg);
      }
    },
    remove() {
      deleteArr(this.listitem, $api_eap.user.delete, this.list);
      this.tree();
    },
    go(node) {
      this.teamId = node.id;
      this.label = node.label;
      this.accText = '';
      this.nameText = '';
      sessionStorage.setItem('userIdval', node.id);
      this.check2 = false;
      this.reRun(this.check2);
      this.editParams.teamName = node.label;
      this.editParams.teamId = node.id;
      if (node.pid !== '-1') {
        this.loadGridWithTeam(node.id);
        //let obj = findInTree(this.dataTree, node.pid, 'id');
        this.preTit = node.name  + '下属组织';
      } else {
        console.log("click root node");
      }
    },
    loadGridWithTeam(teamId){
      //this.$message.success('错了哦，这是一条错误消息');
      let par = {
        teamId: teamId,
        // account: this.accText,
        // name: this.nameText,
        // status: 'workingStatus',
        // deleteFlag: 'WEI_SHAN_CHU',
        // pageNo: value ? value.page : this.pagination.page,
        // pageSize: value ? value.size : this.pagination.size
      };

      httpKit.post($api_eap.user.search, par).then(res => {
        this.refreshing = false;
        if (res.data.code === '200') {
          // res.data.data.map(res => {
          //   if (res.status === 'leave') {
          //     res.status = '离职';
          //     // leave.push(res);
          //   } else if (res.status === 'live') {
          //     res.status = '在职';
          //   } else if (res.status === 'pause') {
          //     res.status = '新员工停用';
          //   }
          // });
          this.datas = res.data.data;
          // this.pagination.total = +res.data.data.totalElements;
          // this.preTit = '所有用户列表';
        } else {
          if (res.data.code === '500') {
            this.datas = [];
          }
        }
      });

    },
    list(value) {
      let par = {
        teamId: this.teamId,
        account: this.accText,
        name: this.nameText,
        status: 'workingStatus',
        deleteFlag: 'WEI_SHAN_CHU',
        pageNo: value ? value.page : this.pagination.page,
        pageSize: value ? value.size : this.pagination.size
      };
      this.refreshing = true;
      if (this.check2) {
        delete par.teamId;

      } else {
        httpKit.post($api_eap.user.list, par).then(res => {
          this.refreshing = false;
          let leave = [];
          if (res.data.code === '200') {
            res.data.data.page.content.map(res => {
              if (res.status === 'leave') {
                res.status = '离职';
                leave.push(res);
              } else if (res.status === '') {
                res.status = '在职';
              } else if (res.status === 'live') {
                res.status = '活跃';
              }
            });
            this.datas = res.data.data.page.content;
            this.pagination.total = +res.data.data.page.totalElements;
          } else {
            if (res.data.code === '500') {
              this.datas = [];
            }
          }
          this.leavenum = leave.length;
        });
      }
    },
    reRun(val) {
      this.pagination = {
        page: 1,
        size: 10,
        total: 0
      };
      //this.list(val);
    },
    openView() {
      if (checkSelect(this.listitem)) {
        this.user.userId = this.listitem[0].id;
        this.user.name = this.listitem[0].name;
        this.syncView = true;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.el-dialog__wrapper {
  overflow: unset;
}

.rap /deep/ .el-dialog {
  width: 100%;
  height: 100%;
  overflow: auto;
  margin-top: unset !important;
}

.rap /deep/ .el-dialog__header {
  background: #409eff !important;
}

.rap /deep/ .el-dialog__header .el-dialog__headerbtn .el-dialog__close {
  color: #000;
}

.buttons {
  width: 100%;
  padding-left: 10%;
  display: flex;
}

.demosplit {
  height: calc(90vh - 145px);
  overflow-y: scroll;
}
.demosplit::-webkit-scrollbar {
  width: 0;
}
.setScroll /deep/ .ivu-split-wrapper {
  overflow: hidden;
}
</style>
